export default "__VITE_ASSET__4037ea91__"